import React from "react";
import { Button } from "./ui/Button";

interface DealerCTAProps {
  onFindDealerClick?: () => void;
}

export const DealerCTA: React.FC<DealerCTAProps> = ({ onFindDealerClick }) => {
  const handleFindDealer = () => {
    if (onFindDealerClick) {
      onFindDealerClick();
    }
  };
  return (
    <section className="relative h-fit w-full py-16 lg:py-24" id="distributor">
      <div className="absolute inset-0">
        <img
          src="https://picsum.photos/seed/warehouse/1920/800"
          alt="Warehouse"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 w-[90%] lg:w-[70%] mx-auto h-full flex flex-col items-center justify-center text-center">
        <h2 className="text-2xl md:text-3xl lg:text-heading-large text-white font-bold font-open-sans-hebrew mb-8 w-full">
          Available Through An Expanding Sale Center Network Across India.
          {/* <br className="hidden lg:block" /> */}
          
        </h2>

        <Button variant="red" className="font-raleway" onClick={handleFindDealer}>
          Find Nearest Sale Center
        </Button>

        <div className="w-full mt-12 flex md:flex-row justify-between flex-col max-md:items-center gap-8 text-xs text-gray-400 uppercase tracking-wide">
          <span className="flex items-center gap-2 bg-white/20 p-2 rounded-lg backdrop-blur-sm font-raleway text-white w-fit lg:w-[25%]">
            <div className="w-3 h-3 border border-gray-400 rounded-full flex items-center justify-center text-[8px]">
              ✓
            </div>
            500+ Authorized Sale Centers
          </span>
          <span className="flex items-center gap-2 bg-white/20 p-2 rounded-lg backdrop-blur-sm font-raleway text-white w-fit lg:w-[25%]">
            <div className="w-3 h-3 border border-gray-400 rounded-full flex items-center justify-center text-[8px]">
              ✓
            </div>{" "}
            24/7 Support Available
          </span>
          <span className="flex items-center gap-2 bg-white/20 p-2 rounded-lg backdrop-blur-sm font-raleway text-white w-fit lg:w-[25%]">
            <div className="w-3 h-3 border border-gray-400 rounded-full flex items-center justify-center text-[8px]">
              ✓
            </div>{" "}
            Certified Service Centers
          </span>
        </div>
      </div>
    </section>
  );
};
